import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$6 } from './icon.js';
import { d as defineCustomElement$5 } from './tab.js';
import { d as defineCustomElement$4 } from './tabs.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const tileCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0;padding:0}:host p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;padding:0}:host(.header),:host(.header-button){border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:1.5rem}::slotted([slot=footer]){padding-left:1.5rem;padding-right:1.5rem}:host(.tabbed-header) wui-tabs{padding-left:1.5rem;padding-right:1.5rem;padding-top:.5rem}:host(.tile-container){background-color:var(--jw-theme-surface-tile-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;display:flex;flex-direction:column;max-width:100%;position:relative;width:100%}.horizontal-padding{padding-left:1.5rem;padding-right:1.5rem}.vertical-padding{padding-bottom:1.5rem;padding-top:1.5rem}";
const WuiTileTabbedHeaderStyle0 = tileCss;

const WuiTileTabbedHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiTileTabbedHeader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.selectTab = createEvent(this, "selectTab", 3);
        this.tabs = undefined;
        this.activeTabId = undefined;
    }
    render() {
        return (h(Host, { key: '179047a57bc5ecf53383bdf281ef80bc3a7a59b0', class: "tabbed-header" }, h("wui-tabs", { key: '63cb432108230ef4fae491d1377ff758b3c56c6e', tabs: this.tabs, activeTabId: this.activeTabId, onSelectTab: (e) => {
                // re-emit event
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.selectTab?.emit(e.detail);
            } })));
    }
    static get style() { return WuiTileTabbedHeaderStyle0; }
}, [1, "wui-tile-tabbed-header", {
        "tabs": [16],
        "activeTabId": [1025, "active-tab-id"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tile-tabbed-header", "wui-icon", "wui-tab", "wui-tabs", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tile-tabbed-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTileTabbedHeader$1);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tab":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tabs":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTileTabbedHeader = WuiTileTabbedHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTileTabbedHeader, defineCustomElement };

//# sourceMappingURL=wui-tile-tabbed-header.js.map